import React, { useState } from 'react';
import { ArrowLeftIcon, ArrowRightIcon, ChevronDownIcon, ChevronRightIcon, CopyIcon, SplitIcon, LockIcon } from 'lucide-react';
interface RoomsAndManifoldsProps {
  onNext: () => void;
  onBack: () => void;
}
export const RoomsAndManifolds: React.FC<RoomsAndManifoldsProps> = ({
  onNext,
  onBack
}) => {
  const [expandedItems, setExpandedItems] = useState<{
    [key: string]: boolean;
  }>({
    'storey-1': true,
    'storey-1-manifold-1': true
  });
  const toggleExpand = (id: string) => {
    setExpandedItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  // Mock data for rooms and manifolds
  const roomsData = [{
    id: 'storey-1',
    name: 'Storey 1',
    manifolds: [{
      id: 'storey-1-manifold-1',
      name: 'Manifold 1',
      rooms: [{
        id: 'room-1-1',
        name: 'Room 1.1',
        area: 15.2,
        cc: 150,
        pipe: 16,
        circuits: 1,
        length: 92.5,
        floorType: 'Beton',
        tFloor: 24,
        tf: 35,
        tr: 30,
        tag: 'Living Room',
        advancedData: {
          supplyPipe: 5.0,
          deltaT: 5.0,
          ap: 5.0
        }
      }, {
        id: 'room-1-2',
        name: 'Room 1.2',
        area: 12.8,
        cc: 150,
        pipe: 16,
        circuits: 1,
        length: 78.3,
        floorType: 'Beton',
        tFloor: 24,
        tf: 35,
        tr: 30,
        tag: 'Living Room',
        advancedData: {
          supplyPipe: 4.5,
          deltaT: 5.0,
          ap: 4.8
        }
      }, {
        id: 'room-1-3',
        name: 'Room 1.3',
        area: 8.5,
        cc: 100,
        pipe: 16,
        circuits: 1,
        length: 75.0,
        floorType: 'Beton',
        tFloor: 26,
        tf: 35,
        tr: 30,
        tag: 'Bathroom',
        advancedData: {
          supplyPipe: 3.0,
          deltaT: 5.0,
          ap: 4.2
        }
      }]
    }]
  }, {
    id: 'storey-2',
    name: 'Storey 2',
    manifolds: [{
      id: 'storey-2-manifold-1',
      name: 'Manifold 1',
      rooms: [{
        id: 'room-2-1',
        name: 'Room 2.1',
        area: 14.0,
        cc: 150,
        pipe: 16,
        circuits: 1,
        length: 85.0,
        floorType: 'Beton',
        tFloor: 24,
        tf: 35,
        tr: 30,
        tag: 'Living Room',
        advancedData: {
          supplyPipe: 4.8,
          deltaT: 5.0,
          ap: 4.9
        }
      }, {
        id: 'room-2-2',
        name: 'Room 2.2',
        area: 10.5,
        cc: 100,
        pipe: 16,
        circuits: 1,
        length: 90.0,
        floorType: 'Beton',
        tFloor: 26,
        tf: 35,
        tr: 30,
        tag: 'Bathroom',
        advancedData: {
          supplyPipe: 3.5,
          deltaT: 5.0,
          ap: 4.5
        }
      }]
    }]
  }];
  return <div className="mb-20" data-id="element-286">
      <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-6" data-id="element-287">
        <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-288">
          {/* Left panel - Tree structure */}
          <div className="p-6 border-r border-gray-200" data-id="element-289">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-290">
              Bygningsstruktur
            </h2>
            <div className="space-y-2" data-id="element-291">
              {roomsData.map(storey => <div key={storey.id} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-292">
                  <div className="flex items-center justify-between p-3 bg-gray-50 cursor-pointer hover:bg-gray-100 transition-colors" onClick={() => toggleExpand(storey.id)} data-id="element-293">
                    <div className="font-medium" data-id="element-294">{storey.name}</div>
                    <div data-id="element-295">
                      {expandedItems[storey.id] ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-296" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-297" />}
                    </div>
                  </div>
                  {expandedItems[storey.id] && <div className="pl-4" data-id="element-298">
                      {storey.manifolds.map(manifold => <div key={manifold.id} data-id="element-299">
                          <div className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => toggleExpand(manifold.id)} data-id="element-300">
                            <div className="text-gray-700" data-id="element-301">{manifold.name}</div>
                            <div data-id="element-302">
                              {expandedItems[manifold.id] ? <ChevronDownIcon className="w-4 h-4 text-gray-500" data-id="element-303" /> : <ChevronRightIcon className="w-4 h-4 text-gray-500" data-id="element-304" />}
                            </div>
                          </div>
                          {expandedItems[manifold.id] && <div className="pl-4 pb-2" data-id="element-305">
                              {manifold.rooms.map(room => <div key={room.id} className="p-2 text-sm text-gray-600 hover:bg-gray-50 cursor-pointer rounded-md" data-id="element-306">
                                  {room.name}
                                </div>)}
                            </div>}
                        </div>)}
                    </div>}
                </div>)}
            </div>
          </div>
          {/* Right panel - Room setup table */}
          <div className="col-span-2 p-6" data-id="element-307">
            <h2 className="text-xl font-semibold text-gray-800 mb-4" data-id="element-308">
              Rumopsætning
            </h2>
            <div className="overflow-x-auto" data-id="element-309">
              <table className="min-w-full divide-y divide-gray-200" data-id="element-310">
                <thead data-id="element-311">
                  <tr data-id="element-312">
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-313">
                      Rum
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-314">
                      Areal (m²)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-315">
                      C/C (mm)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-316">
                      Rør (Ø)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-317">
                      Kredse
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-318">
                      Længde (m)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-319">
                      Gulvopbygning
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-320">
                      T-floor (°C)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-321">
                      Tf (°C)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-322">
                      Tr (°C)
                    </th>
                    <th className="px-4 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-323">
                      Handlinger
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200" data-id="element-324">
                  {roomsData.flatMap(storey => storey.manifolds.flatMap(manifold => manifold.rooms.map(room => <tr key={room.id} className="hover:bg-gray-50" data-id="element-325">
                          <td className="px-4 py-3 whitespace-nowrap" data-id="element-326">
                            <div data-id="element-327">
                              <div className="font-medium text-gray-800" data-id="element-328">
                                {room.name}
                              </div>
                              <div className="text-xs text-gray-500 mt-1 inline-block px-2 py-0.5 bg-gray-100 rounded-full" data-id="element-329">
                                {room.tag}
                              </div>
                            </div>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-330">
                            {room.area}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-331">
                            {room.cc}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-332">
                            {room.pipe}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-333">
                            {room.circuits}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-334">
                            {room.length}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-335">
                            {room.floorType}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-336">
                            {room.tFloor}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-337">
                            {room.tf}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-338">
                            {room.tr}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600" data-id="element-339">
                            <div className="flex space-x-2" data-id="element-340">
                              <button className="p-1 text-gray-500 hover:text-gray-700" title="Kopier rum" data-id="element-341">
                                <CopyIcon className="w-4 h-4" data-id="element-342" />
                              </button>
                              <button className="p-1 text-gray-500 hover:text-gray-700" title="Split kredse" data-id="element-343">
                                <SplitIcon className="w-4 h-4" data-id="element-344" />
                              </button>
                              <button className="p-1 text-gray-500 hover:text-gray-700" title="Lås parameter" data-id="element-345">
                                <LockIcon className="w-4 h-4" data-id="element-346" />
                              </button>
                            </div>
                          </td>
                        </tr>)))}
                </tbody>
              </table>
            </div>
            <div className="mt-4" data-id="element-347">
              <div className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-xs text-gray-700" data-id="element-348">
                <span className="font-medium mr-1" data-id="element-349">Avanceret:</span>
                Supply Pipe 5,0 m · ΔT 5,0 °C · AP mål 5,0 kPa
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-between" data-id="element-350">
        <button onClick={onBack} className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors" data-id="element-351">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-352" />
          Tilbage
        </button>
        <button onClick={onNext} className="flex items-center px-4 py-2 bg-[#E3000F] text-white rounded-md hover:bg-red-700 transition-colors" data-id="element-353">
          Fortsæt
          <ArrowRightIcon className="w-4 h-4 ml-2" data-id="element-354" />
        </button>
      </div>
    </div>;
};